import { useMedia } from 'react-use';

export function useIsMobileWide() {
    return useMedia('(max-width: 683px)');
}
